import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../../../../core/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { displayValues, spekwoType } from '../../../../utils';

@Component({
  selector: 'app-preview-supporting-info',
  templateUrl: './preview-supporting-info.component.html',
  styleUrls: ['./preview-supporting-info.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class PreviewSupportingInfoComponent implements OnInit {

  formValues = spekwoType;
  displayValues = displayValues;

  finalFullSpekwoRes = []
  finalSpecificSpekwoRes = []

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PreviewSupportingInfoComponent>) { }

  ngOnInit() {
    console.log('form-data', this.data);
    this.setFullSpekwoDataFormat();
    this.setSpecificSpekwoDataFormat();
  }


  setFullSpekwoDataFormat(){
    let localArray = this.data.itemsAndDescriptions;

    if(localArray && localArray.length > 0){
      for( let i = 0; i < localArray.length; i++){
        let rowData = localArray[i];
  
        if(localArray[i].id !=  null ||  localArray[i].description !=  "" || localArray[i].image !=  ""){
  
          let obj ={
            id: rowData && rowData['id'] ? rowData['id'] : null,
            description: rowData && rowData['description'] ? rowData['description'] : '',
            image: rowData && rowData['image'] ? rowData['image'] : '',
          }
  
          this.finalFullSpekwoRes.push(obj);
        }
      }
    }
    else{
      this.finalFullSpekwoRes = [];
    }
  }


  setSpecificSpekwoDataFormat(){
    let localArray = this.data.itemsNumber;
    
    for( let i = 0; i < localArray.length; i++){
      let rowData = localArray[i];

      if(localArray[i] != ''){

        let obj ={
          item: rowData ? rowData : '',
        }

        this.finalSpecificSpekwoRes.push(obj);
      }
    }
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/preview-supporting-info/preview-supporting-info.component.ts